export default function() {
	return {
		currentWindowScroll: 0,
		currentHeaderScroll: 0,
		lowestScroll: 0,
		isTranslationsReady: false,
	};
}
